import { BaseEnum } from "../../../enums/baseEnum"

const listPipelineConfigTypeEnum: Array<PipelineConfigType> = [];

export class PipelineConfigType extends BaseEnum {
  static RECRUITMENT = new PipelineConfigType(1, 'RECRUITMENT', 'Vaga', 'primary');
  static CANDIDATE = new PipelineConfigType(2, 'CANDIDATE', 'Seleção de Candidato', 'info');

  constructor(public id: number, public value: string, public label: string, public className: string) {
    super(id, value, label, className)
    listPipelineConfigTypeEnum.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listPipelineConfigTypeEnum;
  }

  public static getById(id: number): PipelineConfigType | undefined {
    return listPipelineConfigTypeEnum.find(item => item.id === id);
  }

  public static getBy(value: string): PipelineConfigType | undefined {
    return listPipelineConfigTypeEnum.find(item => item.value === value);
  }
}

